<template>
    <div>
        <v-container fluid :style="{ 'min-height': '800px' }">
            <v-container class="contain-width">
                <h1 class="mt-6 mb-6">How it works</h1>

              <v-row>
                <v-col
                    cols="12"
                    md="8"
                    offset-md="2"
                >
                  <p class="intro mb-6">Findmykit is a solution to the vast and expensive problem of lost property. In an ever increasing throw away world, Findmykit helps both reduce the need to replace costly items, and prevents contributing to CO2 emissions from waste incineration. When an item is found it can be scanned by a vetted member of our network, and an instant email/sms notification is delivered to the registered owner, avoiding the cost and inconvenience of replacing lost items.</p>

                  <vimeo-player ref="player" video-id="413882664" @ready="onReady" class="player-container" :options="options">
                  </vimeo-player>
                </v-col>
              </v-row>

              <p class="intro mt-6 mb-6">We have provided a selection of video guides below to help.</p>
                <v-row>
                    <v-col
                            cols="12"
                            sm="6"
                            md="4"
                            v-for="item in guides"
                            v-bind:key="item.id"
                    >
                      <v-hover>
                        <template v-slot="{ hover }">
                        <v-card
                                class="mx-auto product-card"
                                outlined
                                :elevation="hover ? 4 : 2"
                        >
                            <v-card-title class="headline primary--text">{{item.heading}}</v-card-title>

                            <v-img
                                    class="white--text align-end mb-2"
                                    height="200px"
                                    :src="item.image"
                            >

                            </v-img>

                            <v-card-actions>
                                <v-btn class="small" rounded elevation="0" color="primary" @click="navigate('guide', item)">
                                    {{ $t('buttons.Find out more') }}
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                        </template>
                      </v-hover>
                    </v-col>
                </v-row>
            </v-container>
        </v-container>
        <Footer />
    </div>
</template>

<script>

    import Footer from './Footer.vue'
    import {i18n} from "../i18n";
    import axios from 'axios/index'
    import {mapState} from "vuex";

    export default {
        name: "HowItWorks",
        metaInfo() {
          return {
            title: this.capitalizeFirstLetter(this.brand) + ' - ' + i18n.t('headings.How it works'),
            htmlAttrs: {
              lang: i18n.locale
            },
            meta: [
              { name: 'description', content: i18n.t('How it works; watch our video guides to answer your frequently asked questions') }
            ]
          }
        },
        components: {
            'Footer': Footer
        },
        data () {
            return {
                guides: [],
                options: {'responsive': true, 'dnt': true},
                playerReady: false
            }
        },
        mounted () {

            window.scrollTo(0,0);

            window.prerenderReady = true;

            this.loadGuides();
        },
        computed: {
          ...mapState({
            brand: state => state.brand,
            brandName: state => state.brandName
          }),
          getBackground() {
            if (this.brand === 'neotag') {
              return require('@/assets/neotag-background.jpg')
            }
            else {
              return require('@/assets/neotag-background.jpg')
            }
          },
        },
        methods: {
            capitalizeFirstLetter(string) {
              return string.charAt(0).toUpperCase() + string.slice(1);
            },
            navigate(routeName, item) {
                this.$router.push({name: routeName, params: { slug: item.slug }})
            },
            onReady() {
              this.playerReady = true
            },
            loadGuides() {

              this.loading = true
              this.guides = [];

              const instance = axios.create({
                baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
                headers: {'Accept-Language': this.locale},
                withCredentials: true,
              });

              instance
                  .get('/api/guides')
                  .then(response => {
                    this.guides = response.data.data
                  })
                  .catch(error => {
                    console.log(error)
                  })
            },
        }
    }
</script>

<style scoped>
    button {
        text-transform: none;
    }
    .product-card {
        border-radius: 15px;
        border: none !important;
        height: 100%;
        padding-bottom: 60px;
    }
    .product-card .v-card__actions {
        padding-left: 15px;
        padding-bottom: 15px;
        position: absolute;
        bottom: 0;
    }

</style>
